<template>
  <el-dialog
    :visible.sync="showEdit"
    width="50%"
    :append-to-body="true"
    @open="handleOpen"
    :modal-append-to-body="true"
    destroy-on-close
    title="新建微站"
    @closed="handleClose"
    :close-on-click-modal="false"
    class="station-edit"
  >
    <el-form ref="form" :model="form" label-position="top" :rules="rules">
      <el-row>
        <el-col :span="12">
          <el-form-item prop="name" label="请填写社团名称">
            <el-input :disabled="this.isCreate==2" size="mini" v-model="form.name" type="text" :rows="1" :maxlength="18" placeholder="请填写社团名称" show-word-limit />
          </el-form-item>
        </el-col>
      </el-row>
<!--      <el-form-item label="请选择学校" prop="school_id">-->
<!--        <span class="d2-mr-5" v-show="form.school_id">-->
<!--          <el-tag effect="dark" type="info" disable-transitions>-->
<!--            <d2-icon name="mortar-board"/>{{schoolName}}-->
<!--          </el-tag>-->
<!--        </span>-->
<!--        <love-search-school-->
<!--          @change="onChangeSchool"-->
<!--          @clear="onClearSelectSchool" />-->
<!--      </el-form-item>-->
      <el-form-item label="请上传社团Logo" prop="avatar">
        <love-element-upload
          :list-type="uploadOption.listType"
          :drag="uploadOption.drag"
          :allow-type="uploadOption.allowType"
          :allow-size="uploadOption.allowSize"
          :disabled="uploadOption.disabled"
          :limit="uploadOption.limit"
          :multiple="uploadOption.multiple"
          :love-path="uploadOption.lovePath"
          :file-list="fileList.image"
          :accept="uploadOption.accept"
          :show-file-list="uploadOption.showFileList"
          @preview="onPreview"
          @remove="onRemove"
          @success="onSuccess" />
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="简介">
            <el-input
              type="textarea"
              :rows="4"
              :maxlength=100
              show-word-limit
              placeholder="请输入内容"
              :autosize="{minRows: 4}"
              size="mini"
              :disabled="this.isCreate==2"
              v-model="form.description">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button size="medium" type="info" @click="handleClose">取消</el-button>
      <axj-button color="#00adb5" v-show="isCreate!=2" size="max" @click="handleSubmit">保存</axj-button>
    </div>
  </el-dialog>
</template>

<script>
const defaultForm = {
  user_id: undefined,
  user_avatar: '',
  user_name: '',
  is_auth: 0,
  school_id: undefined,
  name: '',
  avatar: '',
  background_img: '',
  description: '',
  source_directory: ''
}
import { fetchAssociation,createAssociation,updateAssociation,createAssociationFollower } from "../../../../api/axj-information/axj-information-association"
export default {
  name: "station-edit",
  data(){
    return{
      showEdit:false,
      // 记录社团唯一id
      id: undefined,
      form: Object.assign({}, defaultForm),
      // love element upload 上传文件组件参数
      // 学校名称
      schoolName: '',
      uploadOption: {
        listType: "picture-card",
        drag: false,
        multiple: true,
        allowType: ["image/jpg", "image/jpeg", "image/png"],
        disabled: false,
        limit: 1,
        lovePath:{
          module: "information/association",
          source_directory: "",  // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        allowSize: 4,
        accept: 'image/*',
        showFileList: true
      },
      // fileList
      fileList: {
        image: [],
        video: []
      },
      // web view preview
      webPreview: false,
      // loading
      loading: false,
      // 数据验证
      rules: {
        title: [
          { required: true, message: '社团标题不能为空', trigger: 'change' }
        ],
        school_id: [
          { required: true, message: '请选择学校', trigger: 'change' }
        ],
        avatar: [
          { required: true, message: '请上传社团LOGO', trigger: 'blur,change' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'change' }
        ],
      }
    }
  },
  methods:{
    handleOpen(){
      // 初始化一些公用数据
      // this.initData()
      // 创建 sourceDirectory 规则为 [uuid_打开这页面的时间戳]
      this.uploadOption.lovePath.source_directory = this.$store.getters.getUser.infoUserUid + '_' + Date.parse(new Date()) / 1000
      // 判断编辑状态
      if (this.isCreate==1||this.isCreate==2) {
        // 编辑社团，使用route中的id获取form
        const id = this.stationId
        // data 中的 id，记录待使用
        this.id = parseInt(id)
        // 获取社团数据
        this.handleGetAssistantData(id)
        // if(this.isCreate==2){
        //   this.uploadOption.disabled=true
        // }
      } else if(this.isCreate==0){
        // 发布社团 form 为 default form
        this.form = Object.assign({}, defaultForm)
        this.form.school_id = this.$store.getters.getUser.schoolId
      }
    },
    handleClose(){
      this.fileList={
        image: [],
          video: []
      }
      this.$emit("update:show",false)
    },
    handleGetAssistantData(id) {
      this.loading = true
      fetchAssociation(id)
        .then(res=> {
          const data = res.data
          // 常规数据
          console.log(data)
          this.form = Object.assign({},this.defaultForm, data)
          // 去掉form中的多余属性
          this.$delete(this.form,'created_at')
          this.$delete(this.form,'updated_at')
          this.$delete(this.form,'Count')
          this.$delete(this.form,'School')
          this.$delete(this.form,'User')
          // 若数据库中已经存放了该社团的 source directory
          if (data.source_directory != '') {
            // uploadOption 中也使用该 source directory
            this.uploadOption.lovePath.source_directory = data.source_directory
          }
          // 学校名称
          if(data.school_id) {
            this.schoolName = data.School.name
          }
          // 把头像放入 fileList
          var figure = {
            name: data.name+'LOGO',
            url: data.avatar.indexOf('http') >= 0?data.avatar:this.resourcePrefix.url + data.avatar
          }
          this.fileList.image.push(figure)

          this.loading = false
        })
        .catch(err=> {
          this.$notify.error({
            message: err
          })
          this.loading = false
        })
    },
    // 待组件化
    fetchAssociationManagementCandidatesList(query, callback) {
      if(query) {
        fetchUserList({
          which: 'nickname',
          like: query,
          preload: true
        })
          .then(res=> {
            console.log("res is -> ", res)
            let result = res.lists.map(item=> {
              return {
                value: item.nickname,
                baseinfo: {
                  id: item.id,
                  nickname: item.nickname,
                  avatar: item.avatar
                },
                info: {
                  id: item.InfoUser.id,
                  nickname: item.InfoUser.nickname,
                  avatar: item.InfoUser.avatar
                },
                showclub: {
                  id: item.ExtraShowclubUser.id,
                  nickname: item.ExtraShowclubUser.nickname,
                  avatar: item.ExtraShowclubUser.avatar
                },
                appointment: {
                  id: item.ExtraAppointmentUser.id,
                  nickname: item.ExtraAppointmentUser.nickname,
                  avatar: item.ExtraAppointmentUser.avatar
                },
                party: {
                  id: item.ExtraPartyUser.id,
                  nickname: item.ExtraPartyUser.nickname,
                  avatar: item.ExtraPartyUser.avatar
                },
                competition: {
                  id: item.ExtraCompetitionUser.id,
                  nickname: item.ExtraCompetitionUser.nickname,
                  avatar: item.ExtraCompetitionUser.avatar
                },
                readclub: {
                  id: item.ExtraReadclubUser.id,
                  nickname: item.ExtraReadclubUser.nickname,
                  avatar: item.ExtraReadclubUser.avatar
                },
                lecturehall: {
                  id: item.ExtraLecturehallUser.id,
                  nickname: item.ExtraLecturehallUser.nickname,
                  avatar: item.ExtraLecturehallUser.avatar
                },
              }
            })
            console.log(result)
            callback(result)
          })
      }
    },
    handleSelectManagement(val) {
      console.log(val)
      this.form.user_id = val.info.id
      this.form.user_name = val.info.nickname
      this.form.user_avatar = val.info.user_avatar
      console.log(this.form)
    },
    // handleClearSelectManagement() {
    //   this.form.user_id = undefined
    //   this.form.user_name = ''
    //   this.form.user_avatar = ''
    // },
    onChangeSchool(val) {
      if(val) {
        console.log("true", val)
        this.form.school_id = val.value
        this.schoolName = val.label
      } else {
        this.form.school_id = null
        this.schoolName = ''
      }
    },
    onClearSelectSchool() {
      this.form.school_id = this.info.School.id
      this.schoolName = this.info.School.name
    },
    onPreview(file) {
      console.log(file)
      console.log(this.fileList)
    },
    onRemove(file, fileList) {
      this.form.avatar = ''
      this.fileList.image = []
    },
    onSuccess(response) {
      // 保存返回值
      const file = {
        uid: response.uid,
        name: response.old_name,
        url: response.url,
        status: "success"
      }
      this.fileList.image[0] = file
      this.form.avatar = response.url
    },
    handleSubmit(status) {
      // 表单校验
      this.$refs['form'].validate(async (valid) => {
        if(valid) {
          // 补充表单信息
          this.form.status = status
          // uploadOption.lovePath.source_directory 中保存的为社团的 source_directory
          this.form.source_directory = this.uploadOption.lovePath.source_directory
          // 头像处理
          this.form.avatar = this.form.avatar.indexOf('http')>=0?this.form.avatar.slice(this.resourcePrefix.url.length):this.form.avatar
          // 创建社团时
          if(this.isCreate==0) {
            this.form.user_id = this.form.user_id?this.form.user_id:this.$store.getters.getUser.infoUserUid
            this.form.user_name = this.form.user_name?this.form.user_name:this.info.nickname
            this.form.user_avatar = this.form.user_avatar?this.form.user_avatar:this.info.avatar
            this.id = await this.handleCreateAssistant(this.form)
            // 创建管理员与这个社团的关联
            await this.handleCreateManagementRelation(this.id, this.form.user_id)
            this.$nextTick(()=> {
              // this.$router.go(-1)
              this.$emit("success")
            })
          } else if(this.isCreate==1){
            await this.handleUpdateAssistant(this.form)
            await this.handleUpdateAssistantStatus(this.form)
            // // 创建管理员与这个社团的关联
            // await this.handleCreateManagementRelation(this.id, this.form.user_id)
            this.$nextTick(()=> {
              // this.$router.go(-1)
              this.$emit("success")
            })
          }
        }
      })
      console.log(this.form)
    },
    handleCloseSubmit() {
      // 取消修改
      this.$nextTick(()=> {
        this.$router.go(-1)
      })
    },
    handleCreateAssistant(form) {
      return new Promise((resolve, reject)=> {
        this.loading = true
        createAssociation(form)
          .then(res=> {
            this.$notify({
              message: form.status == 0 ? '保存成功!' : '社团已成功发布!',
              type: 'success',
              duration: 2000
            })
            this.loading = false
            resolve(res.data.id)
          })
          .catch(err=> {
            this.$notify.error({
              message: '社团发布失败，请重试!',
              duration: 2000
            })
            this.loading = false
            reject(err)
          })
      })
    },
    handleCreateManagementRelation(aid, uid) {
      return new Promise((resolve, reject)=> {
        createAssociationFollower({
          association_id: aid,
          user_id: uid,
          status: 1 // 1 表示已加入状态
        })
          .then(res=> {
            resolve(res)
          })
          .catch(err=> {
            reject(err)
          })
      })
    },
    handleUpdateAssistant(form) {
      return new Promise((resolve, reject)=> {
        // 修改社团内容
        this.loading = true
        updateAssociation(form)
          .then(res=> {
            resolve(res)
          })
          .catch(err=> {
            reject(err)
          })
      })
    },
    handleUpdateAssistantStatus(form) {
      return new Promise((resolve, reject)=> {
        // 如果 thumb_sum 等从 非0 再修改为 0 的时候就需要用 where 修改了
        updateAssociation({
          id: form.id,
          where: JSON.stringify({
            status: form.status,
            is_comment: form.is_comment
          })
        })
          .then(res=> {
            this.$notify({
              message: form.status == 0 ? '保存成功!' : '社团修改成功!',
              type: 'success',
              duration: 2000
            })
            this.loading = false
            resolve(res)
          })
          .catch(err=> {
            this.$notify.error({
              message: '修改社团失败，请重试!',
              duration: 2000
            })
            this.loading = false
            reject(err)
          })
      })
    },
  },
  watch:{
    show(v){
      this.showEdit=v
    }
  },
  props:{
    isCreate: {
      type: Number,
      default: 0
    },
    show:{
      type:Boolean,
      default:false
    },
    stationId:{
      type:Number,
      default:0
    }
  },
  computed:{
    info(){
      return this.$store.getters.getUser.info
    },
    resourcePrefix(){
      return this.$store.getters.getResourcePrefix
    }
  }
}
</script>

<style slot-scope lang="scss">
.d2-display-center{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .d2-footer-right {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-information/axj-station/action/station-edit.vue